export const notebookThemes = {
    lavender: {
        pageBg: 'bg-violet-50',
        pageGradient: 'linear-gradient(to bottom, #faf5ff, #ede9fe)',
        lineColor: '#c4b5fd',
        spineGradient: 'linear-gradient(to right, #7c3aed 0%, #8b5cf6 20%, #a78bfa 50%, #8b5cf6 80%, #7c3aed 100%)',
        textPrimary: 'text-violet-900',
        textSecondary: 'text-violet-700',
        accentBg: 'bg-violet-100/50',
        buttonBg: 'bg-violet-600',
        buttonHover: 'hover:bg-violet-700',
        iconBg: 'bg-violet-100',
    },
    sky: {
        pageBg: 'bg-sky-50',
        pageGradient: 'linear-gradient(to bottom, #f0f9ff, #e0f2fe)',
        lineColor: '#7dd3fc',
        spineGradient: 'linear-gradient(to right, #0284c7 0%, #0ea5e9 20%, #38bdf8 50%, #0ea5e9 80%, #0284c7 100%)',
        textPrimary: 'text-sky-900',
        textSecondary: 'text-sky-700',
        accentBg: 'bg-sky-100/50',
        buttonBg: 'bg-sky-600',
        buttonHover: 'hover:bg-sky-700',
        iconBg: 'bg-sky-100',
    },
    sage: {
        pageBg: 'bg-emerald-50',
        pageGradient: 'linear-gradient(to bottom, #ecfdf5, #d1fae5)',
        lineColor: '#6ee7b7',
        spineGradient: 'linear-gradient(to right, #059669 0%, #10b981 20%, #34d399 50%, #10b981 80%, #059669 100%)',
        textPrimary: 'text-emerald-900',
        textSecondary: 'text-emerald-700',
        accentBg: 'bg-emerald-100/50',
        buttonBg: 'bg-emerald-600',
        buttonHover: 'hover:bg-emerald-700',
        iconBg: 'bg-emerald-100',
    },
    coral: {
        pageBg: 'bg-orange-50',
        pageGradient: 'linear-gradient(to bottom, #fff7ed, #ffedd5)',
        lineColor: '#fdba74',
        spineGradient: 'linear-gradient(to right, #ea580c 0%, #f97316 20%, #fb923c 50%, #f97316 80%, #ea580c 100%)',
        textPrimary: 'text-orange-900',
        textSecondary: 'text-orange-700',
        accentBg: 'bg-orange-100/50',
        buttonBg: 'bg-orange-600',
        buttonHover: 'hover:bg-orange-700',
        iconBg: 'bg-orange-100',
    },
    rose: {
        pageBg: 'bg-pink-50',
        pageGradient: 'linear-gradient(to bottom, #fdf2f8, #fce7f3)',
        lineColor: '#f9a8d4',
        spineGradient: 'linear-gradient(to right, #db2777 0%, #ec4899 20%, #f472b6 50%, #ec4899 80%, #db2777 100%)',
        textPrimary: 'text-pink-900',
        textSecondary: 'text-pink-700',
        accentBg: 'bg-pink-100/50',
        buttonBg: 'bg-pink-600',
        buttonHover: 'hover:bg-pink-700',
        iconBg: 'bg-pink-100',
    },
    honey: {
        pageBg: 'bg-amber-50',
        pageGradient: 'linear-gradient(to bottom, #fffbeb, #fef3c7)',
        lineColor: '#fcd34d',
        spineGradient: 'linear-gradient(to right, #d97706 0%, #f59e0b 20%, #fbbf24 50%, #f59e0b 80%, #d97706 100%)',
        textPrimary: 'text-amber-900',
        textSecondary: 'text-amber-700',
        accentBg: 'bg-amber-100/50',
        buttonBg: 'bg-amber-600',
        buttonHover: 'hover:bg-amber-700',
        iconBg: 'bg-amber-100',
    },
};
export const themeColorMap = {
    lavender: { from: '#7c3aed', to: '#a78bfa' },
    sky: { from: '#0284c7', to: '#38bdf8' },
    sage: { from: '#059669', to: '#34d399' },
    coral: { from: '#ea580c', to: '#fb923c' },
    rose: { from: '#db2777', to: '#f472b6' },
    honey: { from: '#d97706', to: '#fbbf24' },
};
